import session from '../plugins/session'
import http from '../plugins/http'
import store from '../store/index'
import { get } from 'lodash'
import { encrypt, existHierarchy } from '../plugins/helpers'
import { origensAcesso } from '../plugins/constants'
import { salvarDadosHierarquia } from '@/webservice/hierarquiaComercial'
import { IconesPorModalidade } from '../plugins/iconsProdutosById'

export async function autenticar (login, senha, savepass = false, originLoginAfv = false) {
  return auth(login, senha, '/usuarios/login', savepass, originLoginAfv, false)
}

export async function autenticarNewCon (login, senha, originLoginLinkExterno = false) {
  return auth(login, senha, '/loginexterno', false, false, originLoginLinkExterno)
}
export async function autenticarNewConEscritorio (token) {
  return authEscritorio(token, '/loginexterno')
}

export async function autenticarNewConEscritorio2 (token) {
  const dataLogin = await authEscritorio2(token, '/loginexterno')
  session.set('origem_acesso', origensAcesso.sso)
  return dataLogin
}

export async function autenticarNewConParceiro (token) {
  return authExterno(token, '/loginexternoapi')
}

export async function setarDadosDaSessao (dadosUsuario) {
  return noAuth(dadosUsuario)
}
export async function autenticarPainel (login, senha) {
  store.commit('setAdditionalLoadingText', 'Autenticando! Por favor, aguarde.')
  return http.post('/painel/login', {
    _l: login,
    _s: senha
  }, {
    options: { unguarded: true, showAdditionalLoadingText: true }
  })
    .then(res => {
      notifyOtherTabs()
      const token = res.data['Token']
      const filiais = _.get(res.data, 'FiliaisVenda.FilialVenda', [])
      const unidades = res.data['UnidadesNegocio']
      const nome = res.data['nome']
      const produtos = res.data['Produtos']['Produto']
      const planos_venda = res.data['PlanosVenda']
      const id_comissionado_master = res.data['ID_Comissionado_Master']
      const super_admin = res.data['super_admin']
      const exibe_contratos_painel = res.data['exibe_contratos_painel']
      const exibe_contratos_sistema = res.data['exibe_contratos_sistema']
      const exibe_reenvio_whatsapp = res.data['exibe_reenvio_whatsapp']
      const tempo_alertas_erro = res.data['tempo_alertas_erro']
      const tempo_alertas_variados = res.data['tempo_alertas_variados']
      const exibe_reenvio_email = res.data['exibe_reenvio_email']
      const permite_logar_tela_login = res.data['permite_logar_tela_login']
      const permite_multiplicar_cota = res.data['permite_multiplicar_cota']
      const funcionalidades_permitidas = res.data['funcionalidades_permitidas']
      const perfil_adm = res.data['perfil_adm']
      const sessao_painel = true
      const vendas_backoffice = res.data.vendas_backoffice
      const id_usuario = res.data['ID_Usuario']
      const id_usuario_interno = res.data.id_usuario_interno
      const empresas = _.get(res.data, 'Empresas.Empresa', [])
      const permissao_perfil = res.data.permissao_perfil
      const broker_fluxo_vendas_comum = res.data['broker_fluxo_vendas_comum']
      const broker_politica_vendas = res.data['broker_politica_vendas']

      session.set({
        login,
        token,
        empresas,
        unidades,
        filiais,
        produtos,
        planos_venda,
        id_comissionado_master,
        super_admin,
        exibe_contratos_painel,
        exibe_contratos_sistema,
        exibe_reenvio_whatsapp,
        exibe_reenvio_email,
        permite_logar_tela_login,
        permite_multiplicar_cota,
        funcionalidades_permitidas,
        perfil_adm,
        nome,
        sessao_painel,
        vendas_backoffice,
        id_usuario_interno,
        tempo_alertas_erro,
        tempo_alertas_variados,
        id_usuario,
        _s: encrypt(login, senha, origensAcesso.login_painel),
        permissao_perfil,
        broker_fluxo_vendas_comum,
        broker_politica_vendas
      })

      return res
    })
}

async function noAuth (dados_usuario) {
  session.set('id_usuario', dados_usuario.id_usuario)
  session.set('login', dados_usuario.login)
  session.set('nome', dados_usuario.nome)
  session.set('token', dados_usuario.token)
  session.set('empresas', dados_usuario.empresas)
  session.set('unidades', dados_usuario.unidades)
  session.set('id_comissionado', dados_usuario.id_comissionado)
  session.set('filiais', dados_usuario.filiais)
  session.set('id_ponto_venda', dados_usuario.id_ponto_venda)
  session.set('id_unidade_negocio', dados_usuario.id_unidade_negocio)
  session.set('admin', dados_usuario.admin)
  session.set('exibe_politica_vendas', dados_usuario.exibe_politica_vendas)
  session.set('limite_cotas_para_reservar_ativo', dados_usuario.limite_cotas_para_reservar_ativo)
  session.set('percentual_cotas_disponiveis_ativo', dados_usuario.percentual_cotas_disponiveis_ativo)
  session.set('percentual_cotas_disponiveis', dados_usuario.percentual_cotas_disponiveis)
  session.set('quantidade_cotas_reservar', dados_usuario.quantidade_cotas_reservar)
  session.set('procura_cidade_por_id', dados_usuario.procura_cidade_por_id)
  session.set('tempo_alertas_variados', dados_usuario.tempo_alertas_variados)
  session.set('tempo_alertas_erro', dados_usuario.tempo_alertas_erro)
  session.set('exibe_contratos_painel', dados_usuario.exibe_contratos_painel)
  session.set('permite_logar_tela_login', dados_usuario.permite_logar_tela_login)
  session.set('permite_multiplicar_cota', dados_usuario.permite_multiplicar_cota)
  session.set('exibe_contratos_sistema', dados_usuario.exibe_contratos_sistema)
  session.set('exibe_reenvio_whatsapp', dados_usuario.exibe_reenvio_whatsapp)
  session.set('exibe_reenvio_email', dados_usuario.exibe_reenvio_email)
  session.set('id_usuario_interno', dados_usuario.id_usuario_interno)
  session.set('produtos', dados_usuario.produtos)
  session.set('vendas_backoffice', dados_usuario.vendas_backoffice)
  session.set('filial', dados_usuario.filial)
  session.set('identificador_representante_tribanco', dados_usuario.identificador_representante_tribanco)
  session.set('unidades_condicoes_venda', dados_usuario.unidades_condicoes_venda)
  session.set('broker_fluxo_vendas_comum', dados_usuario.broker_fluxo_vendas_comum)
  session.set('broker_politica_vendas', dados_usuario.broker_politica_vendas)

  if (!session.get('autenticar')) {
    const produtos = dados_usuario.produtos
    salvaModalidades(produtos)
  }
}
async function authGeral (params, url) {
  localStorage.clear()
  store.commit('setAdditionalLoadingText', 'Autenticando! Por favor, aguarde.')
  return http.post(url, params, {
    options: { unguarded: true, showAdditionalLoadingText: true }
  }).then(res => {
    notifyOtherTabs()
    const login = params._l ? params._l : ''
    const token = res.data['Token']
    const id_usuario = res.data['ID_Usuario']
    const nome = res.data['NM_Pessoa']
    const filiais = res.data['FiliaisVenda']['FilialVenda']
    let unidades = []
    if (!existHierarchy(res.hierarquia_comercial)) {
      unidades = res.data['UnidadesNegocio']
    }
    const admin = res.data['admin']
    const empresas = _.get(res.data, 'Empresas.Empresa', [])
    const id_comissionado = res.data['ID_Comissionado']
    const id_unidade_negocio = res.data['ID_Unidade_Negocio']
    const id_ponto_venda = res.data['ID_Ponto_Venda']
    const exibe_politica_vendas = res.data.exibe_politica_vendas
    const limite_cotas_para_reservar_ativo = res.data.limite_cotas_para_reservar_ativo
    const percentual_cotas_disponiveis_ativo = res.data.percentual_cotas_disponiveis_ativo
    const percentual_cotas_disponiveis = res.data.percentual_cotas_disponiveis
    const quantidade_cotas_reservar = res.data.quantidade_cotas_reservar
    const procura_cidade_por_id = res.data.procura_cidade_por_id
    const tempo_alertas_variados = res.data.tempo_alertas_variados
    const tempo_alertas_erro = res.data.tempo_alertas_erro
    const exibe_contratos_painel = res.data.exibe_contratos_painel
    const exibe_contratos_sistema = res.data.exibe_contratos_sistema
    const exibe_reenvio_whatsapp = res.data.exibe_reenvio_whatsapp
    const exibe_reenvio_email = res.data.exibe_reenvio_email
    const permite_logar_tela_login = res.data['permite_logar_tela_login']
    const permite_multiplicar_cota = res.data['permite_multiplicar_cota']
    const id_usuario_interno = res.data.id_usuario_interno
    const produtos = get(res.data, 'Produtos.Produto')
    const unidades_condicoes_venda = res.data.unidades_condicoes_venda
    const broker_fluxo_vendas_comum = res.data['broker_fluxo_vendas_comum']
    const broker_politica_vendas = res.data['broker_politica_vendas']
    if (typeof params.savepass !== 'undefined' && params.savepass) {
      savePass(params)
    }

    const vendas_backoffice = res.data.vendas_backoffice
    const id_empresa = vendas_backoffice ? 0 : _.get(empresas, '0.ID_Empresa', 0)
    if (token && id_usuario) {
      session.set({
        id_usuario,
        login,
        nome,
        token,
        empresas,
        unidades,
        id_comissionado,
        id_empresa,
        filiais,
        id_ponto_venda,
        id_unidade_negocio,
        admin,
        exibe_politica_vendas,
        limite_cotas_para_reservar_ativo,
        quantidade_cotas_reservar,
        percentual_cotas_disponiveis_ativo,
        percentual_cotas_disponiveis,
        procura_cidade_por_id,
        tempo_alertas_variados,
        tempo_alertas_erro,
        exibe_contratos_painel,
        exibe_contratos_sistema,
        exibe_reenvio_whatsapp,
        exibe_reenvio_email,
        permite_logar_tela_login,
        permite_multiplicar_cota,
        id_usuario_interno,
        produtos,
        vendas_backoffice,
        unidades_condicoes_venda,
        broker_fluxo_vendas_comum,
        broker_politica_vendas
      })
    }

    salvarDadosHierarquia(res.data)

    if (!session.get('autenticar')) {
      const produtos = get(res.data, 'Produtos.Produto')
      salvaModalidades(produtos)
    }

    return res
  })
}
async function auth (login, senha, url, savepass = false, originLoginAfv = false, originLoginLinkExterno = false) {
  let parametros = {
    '_l': login,
    '_s': senha,
    'savepass': savepass,
    originLoginAfv,
    originLoginLinkExterno
  }
  return authGeral(parametros, url)
}
async function authEscritorio (token, url) {
  let parametros = {
    'token': token
  }
  return authGeral(parametros, url)
}
async function authEscritorio2 (token, url) {
  let parametros = {
    'token': token
  }

  const dataLogin = await authGeral(parametros, url)
  return dataLogin
}

async function authExterno (token, url) {
  localStorage.clear()
  notifyOtherTabs()
  return http.post(url, {
    jwt: token
  }, {
    options: { unguarded: true },
    headers: { 'Authorization': 'Bearer ' + token }
  }).then(res => {
    const token = res.data['Token']
    const id_usuario = res.data['ID_Usuario']

    const nome = res.data['NM_Pessoa']
    const filiais = res.data['FiliaisVenda']['FilialVenda']
    let unidades = []
    if (!existHierarchy(res.hierarquia_comercial)) {
      unidades = res.data['UnidadesNegocio']
    }
    const admin = res.data['admin']

    const empresas = _.get(res.data, 'Empresas.Empresa', [])

    const id_comissionado = res.data['ID_Comissionado']
    const id_unidade_negocio = res.data['ID_Unidade_Negocio']
    const id_ponto_venda = res.data['ID_Ponto_Venda']
    const exibe_politica_vendas = res.data.exibe_politica_vendas
    const limite_cotas_para_reservar_ativo = res.data.limite_cotas_para_reservar_ativo
    const quantidade_cotas_reservar = res.data.quantidade_cotas_reservar
    const percentual_cotas_disponiveis_ativo = res.data.percentual_cotas_disponiveis_ativo
    const percentual_cotas_disponiveis = res.data.percentual_cotas_disponiveis
    const procura_cidade_por_id = res.data.procura_cidade_por_id
    const tempo_alertas_variados = res.data.tempo_alertas_variados
    const tempo_alertas_erro = res.data.tempo_alertas_erro
    const exibe_reenvio_whatsapp = res.data.exibe_reenvio_whatsapp
    const exibe_reenvio_email = res.data.exibe_reenvio_email
    const login = res.data.ID_Usuario
    const id_usuario_interno = res.data.id_usuario_interno
    const vendas_backoffice = res.data.vendas_backoffice
    const unidades_condicoes_venda = res.data.unidades_condicoes_venda
    const broker_fluxo_vendas_comum = res.data.broker_fluxo_vendas_comum
    const broker_politica_vendas = res.data.broker_politica_vendas

    const id_empresa = vendas_backoffice ? 0 : _.get(empresas, '0.ID_Empresa', 0)

    if (token && id_usuario) {
      session.set({
        id_usuario,
        login,
        nome,
        token,
        empresas,
        unidades,
        id_comissionado,
        id_empresa,
        filiais,
        id_ponto_venda,
        id_unidade_negocio,
        tempo_alertas_variados,
        tempo_alertas_erro,
        admin,
        exibe_politica_vendas,
        limite_cotas_para_reservar_ativo,
        quantidade_cotas_reservar,
        percentual_cotas_disponiveis_ativo,
        percentual_cotas_disponiveis,
        procura_cidade_por_id,
        exibe_reenvio_whatsapp,
        exibe_reenvio_email,
        id_usuario_interno,
        vendas_backoffice,
        unidades_condicoes_venda,
        broker_fluxo_vendas_comum,
        broker_politica_vendas
      })
    }
    if (!session.get('autenticar')) {
      const produtos = get(res.data, 'Produtos.Produto')
      salvaModalidades(produtos)
    }
    return res
  })
}
/**
 * Recebe um array de produtos, transforma em um array de modalidades contendo seus respectivos produtos e salva na sessão
 * @param res
 * @param produtos
 */
function salvaModalidades (produtos) {
  let modalidades = {}
  produtos.forEach((produto) => {
    let modalidade_id = produto.ST_Modalidade_Catalogo
    let novoProduto = {
      id_produto: produto.ID_Produto,
      nome_produto: produto.NM_Produto.trim(),
      cd_produto: produto.CD_Produto
    }

    // Se já inseriu essa modalidade no array, só insere mais um produto nela
    if (modalidades[modalidade_id]) {
      // Verifica se o produto já existe na modalidade
      let produtoExistente = modalidades[modalidade_id].produtos.find(p => p.id_produto === novoProduto.id_produto)
      if (!produtoExistente) {
        modalidades[modalidade_id].produtos.push(novoProduto)
      }
    } else {
      // Senão, insere uma nova modalidade
      modalidades[modalidade_id] = {
        nome: produto.NM_Modalidade_Catalogo,
        icone: IconesPorModalidade[modalidade_id] ? IconesPorModalidade[modalidade_id] : IconesPorModalidade['default'],
        produtos: [novoProduto]
      }
    }
  })
  session.set({ modalidades })
}

function savePass (params) {
  encrypt(params._l, params._s, origensAcesso.login_painel)
  const _s = params._s

  session.set({ _s })
}

function notifyOtherTabs () {
  localStorage.setItem('newTabOpened', Date.now())
}
